export default "__VITE_ASSET__Dvj2YCz___"